import React, { useState, useEffect } from 'react';
import {
    TiktokMain,
    TiktokIframe
} from './index.style'
import PropTypes from 'prop-types'

const TikTokEmbed = ({data}) => {
    const [videoId, setVideoId] = useState(null);

    useEffect(() => {
        const urlPattern = /https?:\/\/(?:www\.)?tiktok\.com\/@[^/]+\/video\/(\d+)/;
        const idPattern = /^\d+$/;
        const urlMatch = data.videoId.match(urlPattern);
        const idMatch = data.videoId.match(idPattern);
    
        if (urlMatch && urlMatch[1]) {
            setVideoId(urlMatch[1]);
        } else if (idMatch) {
            setVideoId(data.videoId);
        } else {
            console.log(data);
        }
    }, []);

    return (
        <>
            {videoId && (
                <TiktokMain >
                    <TiktokIframe
                        src={`https://www.tiktok.com/player/v1/${videoId}?autoplay=1`}
                        allow="autoplay"
                        title="TikTok video"
                    ></TiktokIframe>
                </TiktokMain>
            )}
        </>
    );
};

export default TikTokEmbed;
